import * as Yup from 'yup';

export default Yup.object().shape({
    code: Yup.string()
        .length(6, 'One-time passcode must be exactly 6 characters')
        .required('One-time passcode is required'),
});
